import { api } from './api';

class DriverQrService {
    /** Shared driver portal URL (one QR for all drivers — mobile OTP login on rsa-vendor). */
    async getPortal() {
        return api.get('/api/auth/driver/qr/portal');
    }

    /** Alias of getPortal — POST kept for backward compatibility with older admin builds. */
    async generate() {
        return api.post('/api/auth/driver/qr/generate', {});
    }
}

export const driverQrService = new DriverQrService();
